import { createContext } from 'react';

import { SupersetContextType } from './types';

export const SupersetContext = createContext({} as SupersetContextType);
